import React, { useEffect } from 'react';
import { CertificatePaymentSuccess } from '@components';
import { scrollTop } from '@share/utils';
import styles from './styles.module.scss';

export function CertificatePaymentSuccessPage(): React.ReactElement {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <div className={styles.root}>
      <CertificatePaymentSuccess />
    </div>
  );
}
